import Vue from 'vue'
import * as types from './mutation-types'

const namespaced = true

const initialState = {
  list: []
}

const mutations = {
  [types.PUT_ELECTION_MODELS] (state, electionModels) {
    electionModels.forEach((model) => {
      const index = state.list.findIndex(m => m.id === model.id)
      if (index > -1) {
        Vue.set(state.list, index, model)
      } else {
        state.list.push(model)
      }
    })
  }
}

const actions = {
  async list (context, raceId) {
    await fetch(`https://forecasting-data.decisiondeskhq.com/2018/prod/races/${raceId}.json`)
      .then(response => response.json())
      .then(data => {
        context.commit(types.PUT_ELECTION_MODELS, data)
        return data
      })
      .catch(error => console.error(error))
  }
}

const getters = {
  list (state) {
    return state.list
  }
}

export default {
  namespaced,
  state: initialState,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/modules/election-models.js